import { useState } from 'react';

import {
  RiDeleteBinLine,
  RiExternalLinkLine,
  RiPencilLine,
} from '@remixicon/react';

import { AttachmentFragment } from '@spotify/confidence-graphql';

import { isRenamableArtifact } from '../../artifactUtils';
import { ArtifactMenu } from '../ArtifactMenu';
import { RenameArtifactDialog } from './RenameArtifactDialog';

interface ArtifactActionsMenuProps {
  artifact: AttachmentFragment;
  resolvedDisplayName?: string;
  navigateLabel?: string;
  onNavigateToResource?: () => void;
  onDelete?: () => void;
}

export const ArtifactActionsMenu = ({
  artifact,
  resolvedDisplayName,
  navigateLabel,
  onNavigateToResource,
  onDelete,
}: ArtifactActionsMenuProps) => {
  const [renameOpen, setRenameOpen] = useState(false);
  const renamable = isRenamableArtifact(artifact);

  return (
    <>
      <ArtifactMenu.Root aria-label="Artifact actions">
        {onNavigateToResource && (
          <ArtifactMenu.Item
            textValue={navigateLabel ?? 'Go to resource'}
            icon={<RiExternalLinkLine size={16} />}
            onClick={onNavigateToResource}
          >
            {navigateLabel ?? 'Go to resource'}
          </ArtifactMenu.Item>
        )}
        {renamable && (
          <ArtifactMenu.Item
            textValue="Rename"
            icon={<RiPencilLine size={16} />}
            onClick={() => setRenameOpen(true)}
          >
            Rename
          </ArtifactMenu.Item>
        )}
        {onDelete && (
          <ArtifactMenu.Item
            textValue="Delete"
            icon={<RiDeleteBinLine size={16} />}
            onClick={onDelete}
            destructive
          >
            Delete
          </ArtifactMenu.Item>
        )}
      </ArtifactMenu.Root>
      {renamable && (
        <RenameArtifactDialog
          artifact={artifact}
          resolvedDisplayName={resolvedDisplayName}
          open={renameOpen}
          onOpenChange={setRenameOpen}
        />
      )}
    </>
  );
};
